export default "__VITE_ASSET__121b9c8c__"